import * as React from 'react';
import { History } from 'history';
import AuthFlowLayout from '../../components/AuthFlowLayout';
import ForgotPasswordFlow from './ForgotPasswordFlow';

type Props = {
  history: History;
};

type State = {
  formType: string;
};

export default class ForgotPassword extends React.Component<Props, State> {
  state = { formType: 'request_code' };

  getTitle() {
    if (this.state.formType === 'request_code') {
      return 'Forgot your password?';
    } else if (this.state.formType === 'reset_password') {
      return 'Create new password';
    }
  }

  render() {
    return (
      <AuthFlowLayout
        // @ts-ignore
        title={this.getTitle()}
        renderMainContent={() => {
          return (
            <ForgotPasswordFlow
              onSuccessfulReset={() => {
                this.props.history.replace('/login');
              }}
              onGoBack={() => {
                this.props.history.replace('/login');
              }}
              handleUnconfirmed={email => {
                this.props.history.replace('/verification-code', {
                  email: email,
                  forgotPassword: true
                });
              }}
              // @ts-ignore
              formType={this.state.formType}
              updateFormType={formType => this.setState({ formType })}
            />
          );
        }}
        renderDesktopRightSidebar={() => {
          return null;
        }}
      />
    );
  }
}
